import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

// Configuration de l'environnement
const isDevelopment = process.env.NODE_ENV === 'development';

// Fonction pour masquer le loader initial
const hideInitialLoader = () => {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.opacity = '0';
    loader.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => {
      loader.style.display = 'none';
      document.body.classList.add('app-loaded');
    }, 300);
  }
};

// Point d'entrée principal
const container = document.getElementById('root');
const root = createRoot(container);

// Rendu de l'application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Masquer le loader une fois React monté
setTimeout(hideInitialLoader, 100);

// Hot Module Replacement pour le développement
if (isDevelopment && module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    root.render(
      <React.StrictMode>
        <NextApp />
      </React.StrictMode>
    );
  });
}

// Service Worker désactivé pour site statique
// if ('serviceWorker' in navigator && !isDevelopment) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then((registration) => {
//         console.log('SW registered: ', registration);
//       })
//       .catch((registrationError) => {
//         console.log('SW registration failed: ', registrationError);
//       });
//   });
// }

// Gestion des erreurs globales
window.addEventListener('error', (event) => {
  console.error('Erreur globale:', event.error);
  
  if (isDevelopment) {
    // En développement, afficher l'erreur
    console.error('Stack trace:', event.error?.stack);
  } else {
    // En production, logger l'erreur (vous pouvez intégrer Sentry ici)
    // Sentry.captureException(event.error);
  }
});

// Gestion des promesses rejetées
window.addEventListener('unhandledrejection', (event) => {
  console.error('Promise rejetée:', event.reason);
  
  if (!isDevelopment) {
    // En production, logger l'erreur
    // Sentry.captureException(event.reason);
  }
});

// Performance monitoring (optionnel)
if (!isDevelopment && 'performance' in window) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const perfData = performance.getEntriesByType('navigation')[0];
      console.log('Performance:', {
        loadTime: perfData.loadEventEnd - perfData.loadEventStart,
        domContentLoaded: perfData.domContentLoadedEventEnd - perfData.domContentLoadedEventStart,
        totalTime: perfData.loadEventEnd - perfData.fetchStart
      });
    }, 0);
  });
}
